export function formatValorMoney(Value) {
    return Number(Value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
    });
}